import { useTranslation } from "react-i18next"
import { Icon, TrashSimple } from "@phosphor-icons/react"
import { Button, ButtonVariant } from "@/components/ui/button"
import {
  Dialog,
  DialogContentCustom,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

type ConfirmationDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  content?: React.ReactNode
  cancelText?: string
  confirmText?: string
  onCancel?: () => void
  onConfirm?: () => void
  isShowConfirmButton?: boolean
  isShowConfirmIcon?: boolean
  confirmIcon?: Icon
  confirmVariant?: ButtonVariant
  isLoading?: boolean
}

const DeprecatedConfirmationDialog = ({
  open,
  onOpenChange,
  title,
  content,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  isShowConfirmButton = true,
  isShowConfirmIcon = true,
  confirmIcon: ConfirmIcon,
  confirmVariant,
  isLoading,
}: ConfirmationDialogProps) => {
  const [t] = useTranslation()

  const handleCancel = () => {
    onOpenChange(false)
    onCancel?.()
  }

  const handleConfirm = () => {
    onConfirm?.()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContentCustom variant="small" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {content && <DialogDescription>{content}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button variant="secondary" onClick={handleCancel} data-testid="confirmation-cancel-button">
            {cancelText ?? t("common.button.keep")}
          </Button>
          {isShowConfirmButton && (
            <Button
              variant={confirmVariant ?? "primary"}
              onClick={handleConfirm}
              disabled={isLoading}
              data-testid="confirmation-delete-button">
              {(ConfirmIcon || isShowConfirmIcon) && (ConfirmIcon ? <ConfirmIcon /> : <TrashSimple />)}
              {confirmText ?? t("common.button.delete")}
            </Button>
          )}
        </DialogFooter>
      </DialogContentCustom>
    </Dialog>
  )
}

export { DeprecatedConfirmationDialog }
